import Vue from "vue";
import Vuesax from "vuesax";
import App from "./App.vue";
import "vuesax/dist/vuesax.css"; //Vuesax styles
import "material-icons/iconfont/material-icons.css";
import "./../src/views/components/calendar-admin/graphComponent";
import './index.css'; // Tailwind CSS styles
// Vuex Store
import store from "./store/store";

// Vue Router
import router from "./router";

// Vue LocalStorage
import VueLocalStorage from "vue-localstorage";

Vue.use(VueLocalStorage, {
  name: "ls",
  bind: true, //created computed members from your variable declarations
});

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: "#22438a",
      success: "rgb(23, 201, 100)",
      danger: "rgb(242, 19, 93)",
      warning: "rgb(255, 130, 0)",
      dark: "rgb(36, 33, 69)",
    },
  },
});

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
import "@/assets/scss/style.scss";
